export default __webpack_public_path__ + "static/media/delete_icon.7f90167f.svg";